import { render, staticRenderFns } from "./ClaimUpdateStatus.vue?vue&type=template&id=3df906a3&"
import script from "./ClaimUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./ClaimUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./ClaimUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimUpdateStatus.vue"
export default component.exports